import { Button } from "@components/atoms/Button"
import { Heading } from "@components/atoms/Heading"
import { CARET_DOWN, CARET_RIGHT, CARET_UP } from "@components/atoms/Icons"
import { Typography } from "@components/atoms/Typography"
import { cn, tv } from "@utils/tw"
import { ReactNode, useState } from "react"

export const Accordion = ({
  title,
  content,
  emergency,
}: {
  title?: string | ReactNode | null
  content?: string | ReactNode | null
  emergency?: {
    url?: string | null
    target?: string | null
    title?: string | null
  } | null
}) => {
  const [open, setOpen] = useState<boolean>(false)

  const renderTitle = () => {
    if (typeof title === "string") {
      return title
    } else if (title !== null && title !== undefined) {
      return title
    }
    return null
  }

  const renderContent = () => {
    if (typeof content === "string") {
      return <Typography as="div" dangerouslySetInnerHTML={{ __html: content ?? "" }} />
    } else if (content !== null && content !== undefined) {
      return content
    }
    return null
  }

  return (
    <div className="flex flex-col border-t border-light-grey">
      <div
        className="flex items-center justify-between cursor-pointer py-4 overflow-hidden"
        onClick={() => setOpen(!open)}
      >
        <h4 className="!transition-all !ease-out !duration-200 !flex items-center gap-4 !translate-x-[-24px] [&_svg]:min-w-[24px] [&_span]:whitespace-nowrap hover:!translate-x-0">
          {CARET_RIGHT} {renderTitle()}
        </h4>

        <div className="flex gap-2 items-center [&>*]:whitespace-nowrap">
          {emergency && (
            <Button
              color="yellow"
              icon="ASSISTANCE"
              iconStyle="left"
              size="small"
              href={emergency.url ?? ""}
              target={emergency.target ? "_blank" : undefined}
            >
              {emergency.title}
            </Button>
          )}
          {open ? <i>{CARET_UP}</i> : <i>{CARET_DOWN}</i>}
        </div>
      </div>
      <div className={cn(contentStyles({ open }))}>{renderContent()}</div>
    </div>
  )
}

const contentStyles = tv({
  base: [
    "h-auto max-h-0 overflow-hidden transition-[max-height] duration-300 ease-movement flex flex-col gap-4 items-start",
    "[&>div>p]:type-body-m [&>div>p]:mb-4",
    "[&>ul]:mb-4 [&>ul>li]:my-3 [&>ul>li]:py-0 [&>ul>li]:type-body-m [&>ul>li]:list-none [&>ul>li]:pl-6 [&>ul>li]:relative",
    "[&>ul>li]:before:content-[''] [&>ul>li]:before:absolute [&>ul>li]:before:top-[8px] [&>ul>li]:before:left-[8px] [&>ul>li]:before:w-[8px] [&>ul>li]:before:h-[8px] [&>ul>li]:before:rounded-[8px] [&>ul>li]:before:bg-yellow",
  ],
  variants: {
    open: {
      true: "max-h-[100vh] overflow-visible",
    },
  },
})
